import api from './api';

export const itineraryVersionService = {
  createVersion: (itineraryId: number) =>
    api.post(`/itinerary-versions/${itineraryId}/create-version`),

  getQuotationForItinerary: (itineraryId: number) =>
    api.get(`/itinerary-versions/${itineraryId}/quotation`),

  getVersions: (quotationId: number) =>
    api.get(`/itinerary-versions/quotation/${quotationId}/versions`),

  getFinancialReconciliation: (quotationId: number) =>
    api.get(`/itinerary-versions/quotation/${quotationId}/financial-reconciliation`),

  getBookingReconciliation: (quotationId: number) =>
    api.get(`/itinerary-versions/quotation/${quotationId}/booking-reconciliation`),
};
